module.exports = __webpack_public_path__ + "duo_ico@2x.f66edb7ed4dba7c20c81e00026944f7b.png";